import React, { useEffect, useState, createRef } from 'react'
import {
  CButton,
  CRow,
  CCol,
  CCard,
  CCardHeader,
  CCardBody,
  CTable,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CNavLink,
  CContainer,
  CForm,
  CFormInput,
  CFormLabel,
  CFormTextarea,
  CCallout,
  CSmartTable,
  CCollapse,
  CTableBody,
  CTableRow,
  CTableDataCell,
  CBadge,
} from '@coreui/react-pro'
import { cilQrCode } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import * as cusUtil from 'src/viewsCommon/CusUtil'
import CusResultModal from 'src/viewsCommon/CusResultModal'
import QRCode from 'qrcode.react'

const SpaceUseDetailUser_pwan = (param) => {
  const [visible, setVisible] = useState(false)
  const [data, setData] = useState({})

  const fetchData = async () => {
    if (param.uid) {
      const url = '/cube_dev_local/api/user/order/orderGoodsPwanDetails/spaceUse/my/' + param.uid
      console.log('detail url: ', url)

      cusUtil
        .axiosGet(url)
        .then((response) => {
          console.log(response)

          setData(response.data)
          setVisible(!visible)
        })
        .catch((error) => {
          console.error('spaceUse detail fail: ', error)
        })
    }
  }

  const TableData = () => {
    const centerName = data.centerName !== null ? `${data.centerName}` : `${data.centerUid}`

    return (
      <CCol xs={12}>
        {data.orderGoodsCodeDetail ? (
          <>
            <CCallout color="primary" className="p-10 mt-0 mb-1 border-radius-0">
              <div className="fs-7 text-medium-emphasis">
                {data.spaceUseUid} Qr 코드 정보 입니다.
              </div>
            </CCallout>
            <CCard
              className="mb-1 bg-light dark:bg-white dark:bg-opacity-10"
              style={{
                display: 'grid',
                placeItems: 'center',
              }}
            >
              {/* <CCardHeader>
              </CCardHeader> */}
              <CCardBody className="bg-light dark:bg-white dark:bg-opacity-10">
                {/* {data.orderGoodsCodeDetail.qrCode} */}
                <div style={{ position: 'relative', width: '300px', height: '300px' }}>
                  <QRCode value={data.orderGoodsCodeDetail.qrCode} size={300} />
                </div>
              </CCardBody>
            </CCard>
          </>
        ) : (
          <></>
        )}

        <CCallout color="primary" className="p-10 mt-0 mb-1 border-radius-0">
          <div className="fs-7 text-medium-emphasis">{data.spaceUseUid} 방문예약 정보 입니다.</div>
        </CCallout>
        <CCard className="mb-4">
          {/* <CCardHeader>
          </CCardHeader> */}
          <CCardBody className="bg-opacity-100 px-0 py-6 small">
            <CTable small bordered align="middle" className="mb-0 border-05">
              <CTableBody>
                <CTableRow>
                  <CTableDataCell className="w-30 px-2">대출번호</CTableDataCell>
                  <CTableDataCell className="px-2">
                    {data.orderGoodsPwanDetailsDetail.orderGoodsPwanDetailsUid}
                  </CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell className="px-2">예약일시</CTableDataCell>
                  <CTableDataCell className="px-2">
                    <div>{cusUtil.getSimpleDtStr(data.startDt)}</div>
                    <div>~ {cusUtil.getSimpleDtStr(data.endDt)}</div>
                  </CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell className="w-30 px-2">예약장소</CTableDataCell>
                  <CTableDataCell className="px-2">{data.centerName}</CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell className="w-30 px-2">대출상태</CTableDataCell>
                  <CTableDataCell className="px-2">
                    <CBadge color="success">
                      {data.orderGoodsPwanDetailsDetail.pwanStatusCdName}
                    </CBadge>
                  </CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell className="px-2">등록일시</CTableDataCell>
                  <CTableDataCell className="px-2">{cusUtil.getDtStr(data.regDt)}</CTableDataCell>
                </CTableRow>
              </CTableBody>
            </CTable>

            {/* <CRow className="mb-0">
              <CFormLabel className="col-sm-2 col-form-label">대출번호</CFormLabel>
              <div className="col-sm-10">
                <CFormInput type="text" size="sm" defaultValue={data.orderUid} readOnly plainText />
              </div>
            </CRow>
            <CRow className="mb-0">
              <CFormLabel className="col-sm-2 col-form-label">시작일시</CFormLabel>
              <div className="col-sm-10">
                <CFormInput
                  type="text"
                  size="sm"
                  defaultValue={cusUtil.getSimpleDtStr(data.startDt)}
                  readOnly
                  plainText
                />
              </div>
            </CRow>
            <CRow className="mb-0">
              <CFormLabel className="col-sm-2 col-form-label">종료일시</CFormLabel>
              <div className="col-sm-10">
                <CFormInput
                  type="text"
                  size="sm"
                  defaultValue={cusUtil.getSimpleDtStr(data.endDt)}
                  readOnly
                  plainText
                />
              </div>
            </CRow> */}
            {/* <CRow className="mb-0">
              <CFormLabel className="col-sm-2 col-form-label">센터</CFormLabel>
              <div className="col-sm-10">
                <CFormInput type="text" size="sm" defaultValue={centerName} readOnly plainText />
              </div>
            </CRow> */}
            {/* <CRow className="mb-0">
              <CFormLabel className="col-sm-2 col-form-label">메모</CFormLabel>
              <div className="col-sm-10">
                <CFormInput type="text" size="sm" defaultValue={data.memo} readOnly plainText />
              </div>
            </CRow> */}
            {/* <CRow className="mb-0">
              <CFormLabel htmlFor="regDt" className="col-sm-2 col-form-label">
                등록일
              </CFormLabel>
              <div className="col-sm-10">
                <CFormInput
                  type="text"
                  size="sm"
                  id="regDt"
                  defaultValue={cusUtil.getDtStr(data.regDt)}
                  readOnly
                  plainText
                />
              </div>
            </CRow>
            <CRow className="mb-0">
              <CFormLabel htmlFor="modDt" className="col-sm-2 col-form-label">
                수정일
              </CFormLabel>
              <div className="col-sm-10">
                <CFormInput
                  type="text"
                  size="sm"
                  id="modDt"
                  defaultValue={cusUtil.getDtStr(data.modDt)}
                  readOnly
                  plainText
                />
              </div>
            </CRow> */}
          </CCardBody>
        </CCard>
      </CCol>
    )
  }

  return (
    <>
      {param.title ? (
        <>
          <CNavLink role="button" onClick={() => fetchData()}>
            {param.title}
          </CNavLink>
        </>
      ) : param.count == 0 ? (
        <CButton
          color="primary"
          className="position-relative px-1 py-1 me-1"
          variant="ghost"
          onClick={() => fetchData()}
        >
          <CIcon icon={cilQrCode} role="button" className="" size="lg" />
        </CButton>
      ) : (
        <CButton
          color="primary"
          className="position-relative px-1 py-1 me-1"
          variant="ghost"
          onClick={() => fetchData()}
        >
          <CIcon icon={cilQrCode} role="button" className="" size="lg" />
          <CBadge color="danger" position="top-end" shape="rounded-pill" size="sm">
            {param.count}
            <span className="visually-hidden">qrcode</span>{' '}
          </CBadge>
        </CButton>
      )}

      <CModal fullscreen backdrop="static" visible={visible} onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle>상세정보</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <TableData />

          {/* <CContainer>
            <CRow>
              <CCol align="center">
                <CButton
                  color="dark"
                  size="sm"
                  className="mx-1 text-white"
                  onClick={() => setVisible(false)}
                >
                  닫기
                </CButton>
              </CCol>
            </CRow>
          </CContainer> */}
        </CModalBody>
        {/* <CRow>
          <CCol xl={12} style={{ marginBottom: '3.5rem' }}></CCol>
        </CRow> */}
      </CModal>
    </>
  )
}

export default SpaceUseDetailUser_pwan
